import React, { FC } from "react";
import classNames from "classnames";
import { graphql, PageProps } from "gatsby";
import { getImage, GatsbyImage, ImageDataLike } from "gatsby-plugin-image";
import { useTranslation } from "gatsby-plugin-react-i18next";

type Props = {
  crossIcon: ImageDataLike;
};

const NotFoundPage: FC<PageProps<Props>> = ({ data }) => {
  const { t } = useTranslation("p_404");
  const crossIcon = getImage(data.crossIcon);

  return (
    <div className="max-w-container mx-auto mb-25 flex flex-col justify-center px-4.5 py-30">
      <div className="text-center">
        <GatsbyImage
          image={crossIcon}
          alt="Not found"
          className={classNames("mb-5 w-20")}
        />
      </div>
      <h1
        className={classNames(
          "text-large text-primary-content mb-7.5 text-center font-semibold",
          "md:text-huge",
        )}
      >
        {t("title")}
      </h1>
      <p
        className={classNames(
          "extra-small text-neutral-content text-center",
          "[&>a]:text-primary-content [&>a]:underline",
          "md:text-regular",
        )}
        dangerouslySetInnerHTML={{ __html: t("body") }}
      />
    </div>
  );
};

export default NotFoundPage;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    crossIcon: file(name: { eq: "icon_cross" }, extension: { eq: "png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED)
      }
    }
  }
`;
